import { defineMessages } from "react-intl";
import { GeoCheckStatus } from "../../contract/pam.js";
const localizedGeoCheckStatus = defineMessages({
  [GeoCheckStatus.Success]: {
    id: "geoCheckStatusSuccess",
    defaultMessage: "Success"
  },
  [GeoCheckStatus.Failed]: {
    id: "loginStatusFailed",
    defaultMessage: "Failed"
  }
});
export {
  localizedGeoCheckStatus
};
//# sourceMappingURL=geoCheckStatus.js.map
